import hyperdom from 'hyperdom'
import {groupBy} from 'lowscore'
import formatDate from 'root-packages/dates/formatDate.js'
import formats from 'root-packages/dates/formats.js'
import {Summary} from '../../defaultFlow/index.js'
import formatPrice from '../../packages/ui-helpers/formatPrice.js'

export default class SummaryDayTour extends Summary {
  constructor (options) {
    super(options)
  }

  renderBreakdownAdditionalProducts (additionalProducts) {
    const currency = this.departure.prices.currency
    const productsToDisplay = additionalProducts.filter((product) => product.productType !== 'hotelPickup')
    const renderAdditionalProduct = (additionalProduct) => <div className="products-breakdown__info">
      <div className="products-breakdown__detail">{additionalProduct.name}</div>
      <div className="products-breakdown__price">
        {formatPrice({currency, amount: additionalProduct.amount})}
      </div>
    </div>

    return productsToDisplay.length ?
      <li className="products-breakdown__item products-breakdown__products">
        {productsToDisplay.map(additionalProduct => renderAdditionalProduct(additionalProduct))}
      </li> : undefined
  }

  renderPassengersBreakdown (breakdown) {
    const roomGroups = groupBy(breakdown.rooms, (room) => room.roomType)
    const promisedFlightPrice = breakdown.promisedFlights ? breakdown.promisedFlights.price || 0 : 0
    return Object.keys(roomGroups).map((roomGroupName) => {
      const roomGroup = roomGroups[roomGroupName]
      const adultsPriceGroups = this.groupPassengersByPrice(roomGroup, 'adult', promisedFlightPrice)
      const childrenPriceGroups = this.groupPassengersByPrice(roomGroup, 'child', promisedFlightPrice)

      return <li class='products-breakdown__item products-breakdown__room' data-test={'trip-summary-room'}>
        <div class='products-breakdown__info'>
          <div class='products-breakdown__headline' data-test={'trip-summary-room-type'}>
            Tour
          </div>
          <div class="products-breakdown__price-container" data-test={'trip-summary-room-price'}>
            {this.renderPassengersBreakdownPrice(adultsPriceGroups, promisedFlightPrice)}
            {this.renderPassengersBreakdownPrice(childrenPriceGroups, promisedFlightPrice)}
          </div>
        </div>
      </li>
    })
  }

  renderTripDetail ({isBeforeTrip}) {
    const renderTripDetailDates = () => {
      return isBeforeTrip
        ? formatDate(this.departure.startDate, formats.human)
        : formatDate(this.departure.endDate, formats.human)
    }

    const renderTripDetailsPlace = () => {
      return isBeforeTrip
        ? `${this.departure.startPlace.city}, ${this.departure.startPlace.country}`
        : `${this.departure.endPlace.city}, ${this.departure.endPlace.country}`
    }
    const renderTripDetailTitle = () => {
      return isBeforeTrip
        ? 'Trip Start'
        : 'Trip End'
    }
    const renderPickupLocation = () => {
      const pickupLocation = this.quoteCriteria?.pickupLocation

      return isBeforeTrip && !!pickupLocation ? <p className="booking-summary__pickup-location">
        <span className="booking-summary__pickup-location--header">Pickup Location: </span>
        <span className="booking-summary__pickup-location--text">{pickupLocation?.associatedProductName}</span>
      </p> : undefined
    }

    return <div className="booking-summary__container booking-summary__departure">
      <div className="booking-summary__icon -new-ui_calendar"></div>
      <div className="booking-summary__desc">
        <div className="booking-summary__title">{renderTripDetailTitle()}</div>
        <p className="booking-summary__date booking-summary__date__item booking-summary__date__depart_origin_country">
          {this.progress.tourLoaded ? renderTripDetailDates() : ''}
        </p>
        <p
          className="booking-summary__location booking-summary__location__start booking-summary__location__origin_country">
          {renderTripDetailsPlace()}
        </p>
        {renderPickupLocation()}
      </div>
    </div>
  }
}
